<template>
  <div class="single-message-dialog-container" v-if="show">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box" :style="{top:top+'px', left: left + 'px', right: right + 'px'}">
      <div class="dialog-content-without-cross">
        <weex-text
          class="font-size-sm-base text-align-center"
          v-html="message"
        ></weex-text>

        <wxc-button
          :text="buttonText"
          :size="buttonSize"
          type="blue"
          class="horizontal-center margin-top-20"
          @wxcButtonClicked="onContinue"
        ></wxc-button>
      </div>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";

export default {
  components: { WxcOverlay, WxcButton },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    message: {
      type: String,
      required: true,
      default: ""
    },

    buttonText: {
      type: String,
      default: "Continue"
    },

    buttonSize: {
      type: String,
      default: "small" //One of {small, medium, big, full}
    },

    top: {
      type: Number,
      default: 20
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    }
  },

  methods: {
    onContinue() {
      this.$emit("onContinue");
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.single-message-dialog-container {
  position: absolute;
  z-index: 10000;
}
</style>
